import { parseDockerfile } from "../dockerfile";
import { ExpectedError } from "../expectedError";
import type { VolumeDirective } from "./types";
import { parseVolumeSpec } from "./spec";

type StepFile = { path: string; content: string };

export function parseVolumeDirective(line: string): VolumeDirective | null {
  const syntaxError = () =>
    new ExpectedError(
      `Invalid VOLUME syntax: ${line}. Expected VOLUME ["<name>[:ro|:scope=run|:access=ro|:concurrency=exclusive]"].`
    );
  const match = line.match(/^VOLUME\s+\["([^"]+)"\]$/);
  if (!match) throw syntaxError();
  return parseVolumeSpec(match[1]!);
}

export function extractVolumes(files: StepFile[]): VolumeDirective[] {
  const dockerfile = files.find((f) => f.path === "Dockerfile");
  if (!dockerfile) throw new Error("Step is missing a Dockerfile");
  const seen = new Set<string>();
  const volumes: VolumeDirective[] = [];
  for (const inst of parseDockerfile(dockerfile.content)) {
    if (inst.kind !== "volume") continue;
    if (seen.has(inst.volume.name)) {
      throw new ExpectedError(
        `Duplicate VOLUME declaration for ${JSON.stringify(inst.volume.name)}. Each volume name may appear at most once per step.`
      );
    }
    seen.add(inst.volume.name);
    volumes.push(inst.volume);
  }
  return volumes;
}
